import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/BotonPSE.png'


const _withScopeId = n => (_pushScopeId("data-v-36cd7de2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "text-xs font-bold text-left text-gris80 md:text-sm" }
const _hoisted_4 = { class: "font-normal" }
const _hoisted_5 = { class: "flex items-center justify-center" }
const _hoisted_6 = { class: "text-xs inline-block font-bold text-primary md:text-sm" }
const _hoisted_7 = { class: "py-4 border-b" }
const _hoisted_8 = { class: "flex flex-col md:items-center md:flex-row justify-between" }
const _hoisted_9 = { class: "flex items-center mb-3" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "text-xs font-bold text-left text-gris80 md:text-sm" }
const _hoisted_12 = {
  key: 0,
  class: "text-xs text-left text-gris120 md:text-sm"
}
const _hoisted_13 = { class: "text-left lg:text-right" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-primary" }, "Saldo total", -1))
const _hoisted_15 = { class: "text-sm font-bold text-gris80" }
const _hoisted_16 = { class: "flex flex-col justify-between md:items-center md:flex-row mt-3 p-2 rounded bg-lightSurface-50" }
const _hoisted_17 = { class: "text-left" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold text-primary" }, [
  /*#__PURE__*/_createTextVNode("Pago mínimo"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_19 = {
  key: 0,
  class: "text-sm text-left font-bold text-gris80"
}
const _hoisted_20 = {
  key: 1,
  class: "text-sm text-left font-bold text-gris80"
}
const _hoisted_21 = { class: "text-left" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold text-primary" }, [
  /*#__PURE__*/_createTextVNode("Fecha límite pago mínimo"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_23 = { class: "text-sm text-left font-bold text-gris80" }
const _hoisted_24 = { class: "text-left" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold text-primary" }, [
  /*#__PURE__*/_createTextVNode("Número de acuerdo"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_26 = { class: "text-sm text-left font-bold text-gris80" }
const _hoisted_27 = { class: "text-left" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold text-primary" }, [
  /*#__PURE__*/_createTextVNode("Estado último pago"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_29 = { class: "text-sm text-left font-bold text-gris80" }
const _hoisted_30 = { class: "flex flex-col justify-between md:items-center md:flex-row md:justify-end pt-4" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 0,
  class: "ml-1"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold text-primary" }, [
  /*#__PURE__*/_createTextVNode("Transacción pendiente"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_34 = { class: "text-sm text-left font-bold text-gris80" }
const _hoisted_35 = ["onClick", "disabled"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "pse",
  class: "btn-pse"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Tooltips = _resolveComponent("Tooltips")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agreements, (agreement) => {
    return (_openBlock(), _createElementBlock("div", {
      key: agreement?.register_type_id
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createTextVNode(" Fecha de obligación: "),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$filters.formatDate(agreement?.created_at)), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(agreement.register_type_state), 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.bindClassState(agreement.register_type_state))
            }, null, 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                class: "obligations__card-img",
                src: agreement?.url_logo,
                alt: agreement?.url_logo
              }, null, 8, _hoisted_10),
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_11, _toDisplayString(agreement?.bank_name), 1),
                (agreement?.notes != '')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(agreement?.notes), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$filters.currency(agreement?.current_debt_value)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              (
                agreement.payment_information[0].sub_register_type != 'Total'
              )
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$filters.currency(agreement.payment_information[0].value)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$filters.currency(agreement.payment_information[0].value)), 1))
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.validatePaymentDate(
                  agreement.payment_information[0].limit_date_payment,
                  agreement.register_type_state
                )), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("span", _hoisted_26, _toDisplayString(agreement.register_type_id), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("span", _hoisted_29, [
                _createVNode(_component_Loader, {
                  class: "inline-block align-text-top",
                  showLoader: _ctx.isLoadingPaymentStatus,
                  styles: 'relative size-xs'
                }, null, 8, ["showLoader"]),
                _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.getLastPaymentStatus(_ctx.getReference(agreement))), 513), [
                  [_vShow, !_ctx.isLoadingPaymentStatus]
                ]),
                _createTextVNode(" - " + _toDisplayString(_ctx.getReference(agreement)), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_Tooltips, { title: "Aquí puede ver más información sobre su acuerdo" }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.viewDetailPlan(agreement, _ctx.obligationType)),
                class: "w-full px-4 py-2 mt-3 md:mt-0 text-sm text-white rounded-lg mr-3 bg-secondary border md:w-auto md:text-sm h-10"
              }, " Más información ", 8, _hoisted_31)
            ]),
            _: 2
          }, 1024),
          (!_ctx.canMakePayment(_ctx.getReference(agreement)))
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.getReference(agreement)), 1)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!_ctx.isLoadingPaymentStatus)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.makePayment(agreement)),
                      class: _normalizeClass(["w-full px-4 py-2 text-sm mt-3 text-white rounded-lg bg-success md:w-64 md:mt-0 md:text-sm order-first md:order-none btn-pse-container h-10", {
              'cursor-not-allowed': !_ctx.valueGreaterThanZero(
                agreement.payment_information[0].value
              ),
            }]),
                      disabled: 
              !_ctx.valueGreaterThanZero(agreement.payment_information[0].value)
            
                    }, [
                      _hoisted_36,
                      _createTextVNode(" Realizar pago mínimo ")
                    ], 10, _hoisted_35))
                  : _createCommentVNode("", true)
              ], 64))
        ])
      ])
    ]))
  }), 128))
}